import { render, staticRenderFns } from "./PublicHolidayRegionsOverview.vue?vue&type=template&id=19aa0340&scoped=true"
import script from "./PublicHolidayRegionsOverview.vue?vue&type=script&lang=js"
export * from "./PublicHolidayRegionsOverview.vue?vue&type=script&lang=js"
import style0 from "./PublicHolidayRegionsOverview.vue?vue&type=style&index=0&id=19aa0340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aa0340",
  null
  
)

export default component.exports